import { combineReducers } from '@reduxjs/toolkit';

import { apartmentsSettingsSlice } from './apartmentsSettingsSlice';
import { engineeringSettingSlice } from './engineeringSettingSlice';

export const settings = combineReducers({
  apartmentsSettings: apartmentsSettingsSlice.reducer,
  engineeringSetting: engineeringSettingSlice.reducer,
});
